import AboutImage from '../../assets/about.jpg'
import CV from '../../assets/cv.pdf'
import {HiDownload} from 'react-icons/hi'
import data from './data'
import Card from '../../components/Card'
import './about.css'

const About = () => {
  return (
    <section id="about" data-aos="fade-in">
        <div className="container about__container">
            <div className="about__left">
                <div className="about__portrait">
                    <img src={AboutImage} alt="About Image" />
                </div>
            </div>
            <div className="about__right">
                <h2>About Me</h2>
                <div className="about__cards">
                    {
                        data.map(item => (
                            <Card key={item.id} className="about__card">
                                <span className='about__card-icon'>{item.icon}</span>
                                <h5>{item.title}</h5>
                                <small>{item.desc}</small>
                            </Card>
                        ))
                    }
                </div>
                <p>
                👋 Hi, I’m Jayesh Solanki, a WordPress & Shopify Full-Stack Developer from Rajkot, India, with 6+ years of professional experience building reliable, scalable, and high-performance websites.
                </p>
                <p>
                I help businesses get online the right way - with industry-standard design, clean architecture, and functionality that supports real growth. Delivering projects on time and building solutions clients love has always been my top priority.
                </p><br/>
                <h4>👉 WordPress Development</h4><br/>
                <ul>
                    <li>Custom Theme & Plugin Development</li>
                    <li>Theme Customization (Custom, Divi, Elementor, WPBakery, FSE)</li>
                    <li>WooCommerce Setup & Customization</li>
                    <li>Payment Gateway & API Integrations</li>
                    <li>HTML to WordPress Conversions</li>
                    <li>WordPress REST API & Third-Party API Integrations</li>
                    <li>Performance Optimization & Security Enhancements</li>
                </ul><br/>
                <h4>👉 Shopify Theme Customization</h4><br/>
                <ul>
                    <li>Shopify Theme Customization using Liquid & JSON Templates</li>
                    <li>Custom Sections & Blocks Development</li>
                    <li>Shopify Storefront & Admin API Integrations</li>
                    <li>Shopify App Integration & Customization</li>
                    <li>Performance Optimization for Shopify Themes</li>
                    <li>UI/UX Improvements & Theme Enhancements</li>
                </ul>
                <a href={CV} download className='btn primary'>Download CV <HiDownload/></a>
            </div>
        </div>
    </section>
  )
}

export default About